import { useCallback } from 'react';
import { adminRolesService } from '../services';
import {
  useResourceCollection,
  useResourceById,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  SingleResourceState,
  MutationState,
} from './useResource';
import { Role } from '../types';

export function useRoles(): ResourceState<Role> & { meta?: any } {
  const fetchFn = useCallback(
    () =>
      adminRolesService.getAll() as unknown as Promise<{ data: Role[]; meta?: any }>,
    []
  );
  return useResourceCollection<Role>(fetchFn);
}

export function useRoleById(
  id: string | null
): SingleResourceState<Role> {
  const resourceId = id;
  const fetchFn = useCallback(
    (roleId: string | number) =>
      adminRolesService.getById(roleId) as unknown as Promise<Role>,
    []
  );
  return useResourceById<Role>(fetchFn, resourceId);
}

export function useCreateRole(
  onSuccess?: (data: Role) => void
): MutationState<Role> {
  const createFn = useCallback(
    (data: any) => adminRolesService.create(data) as unknown as Promise<Role>,
    []
  );
  return useCreateResource<Role>(createFn, onSuccess);
}

export function useUpdateRole(
  onSuccess?: (data: Role) => void
): MutationState<Role> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      return adminRolesService.update(id, data) as unknown as Promise<Role>;
    },
    []
  );
  return useUpdateResource<Role>(updateFn, onSuccess);
}

export function useDeleteRole(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const roleId = data.id || data.documentId || data;
      return adminRolesService.delete(roleId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}
